export const movies = [
  {
    id: "m1",
    title: "星际苍穹",
    year: 2024,
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    director: "陈默",
    actors: ["林澈", "苏晚", "郑川"],
    rating: 8.7,
    tags: ["热门"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20a%20lone%20astronaut%20silhouette%20before%20a%20glowing%20distant%20planet%2C%20deep%20navy%20and%20amber%20colour%20grading%2C%20simple%20dark%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20minimal%20composition%2C%20high%20detail%2C%20editorial%20film%20art%20direction&width=400&height=600&seq=movie-cover-01&orientation=portrait",
    synopsis: "一支深空探测队在穿越未知星门后与地球失去联系，队长必须在有限的能源与破碎的信任之间做出抉择。影片以宏大的宇宙景观与细腻的人际张力，讲述人类在极限环境中对归属的渴望。",
  },
  {
    id: "m2",
    title: "暗夜追凶",
    year: 2023,
    genres: ["犯罪", "悬疑"],
    region: "中国香港",
    director: "麦家辉",
    actors: ["古天乐", "罗嘉良", "梁咏琪"],
    rating: 8.4,
    tags: ["热播"],
    cover: "https://readdy.ai/api/search-image?query=Moody%20noir%20crime%20film%20poster%2C%20a%20detective%20standing%20under%20a%20rainy%20neon%20street%20light%2C%20deep%20navy%20shadows%20with%20warm%20orange%20reflections%2C%20simple%20dark%20background%2C%20cinematic%20lighting%2C%20highly%20detailed%20editorial%20poster%20art%2C%20no%20text&width=400&height=600&seq=movie-cover-02&orientation=portrait",
    synopsis: "一名即将退休的重案组警探在最后一桩连环案件中，发现线索指向自己尘封多年的旧案。潮湿的雨夜、闪烁的霓虹与不肯熄灭的执念，共同拼出一幅关于正义与代价的都市图景。",
  },
  {
    id: "m3",
    title: "雪岭孤鹰",
    year: 2024,
    genres: ["冒险", "剧情"],
    region: "中国大陆",
    director: "高原",
    actors: ["吴京川", "迪丽热巴", "王砚辉"],
    rating: 8.1,
    tags: ["新片"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20mountain%20adventure%20film%20poster%2C%20a%20climber%20silhouette%20on%20a%20snow%20ridge%20at%20dawn%2C%20cold%20navy%20blue%20sky%20with%20warm%20orange%20sunrise%20glow%2C%20simple%20minimal%20background%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=movie-cover-03&orientation=portrait",
    synopsis: "一支高山救援队在暴风雪前夕接到一桩不可能的求救，队长带着对雪山的敬畏与愧疚再次出发。冰裂缝、失温与时间赛跑，影片致敬每一位把生命交给群山的人。",
  },
  {
    id: "m4",
    title: "时光信箱",
    year: 2022,
    genres: ["爱情", "剧情"],
    region: "中国大陆",
    director: "许安",
    actors: ["周迅", "井柏然", "张子枫"],
    rating: 7.9,
    tags: ["口碑"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20romantic%20drama%20film%20poster%2C%20an%20old%20wooden%20letter%20box%20by%20a%20sunlit%20window%2C%20soft%20cream%20and%20amber%20tones%20with%20deep%20navy%20accents%2C%20gentle%20natural%20light%2C%20simple%20minimal%20background%2C%20editorial%20photography%2C%20no%20text&width=400&height=600&seq=movie-cover-04&orientation=portrait",
    synopsis: "小镇上的一句老信箱能寄出写给过去与未来的信，两位素未谋面的陌生人因此产生了跨越时间线的牵连。影片温柔地探讨，如果能够重来，我们究竟想改写哪一段遗憾。",
  },
  {
    id: "m5",
    title: "深海回声",
    year: 2025,
    genres: ["科幻", "惊悚"],
    region: "美国",
    director: "James Rourke",
    actors: ["Elena Cross", "马克·李", "Samuel Ortiz"],
    rating: 8.9,
    tags: ["热门"],
    cover: "https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20thriller%20poster%2C%20a%20deep%20sea%20submersible%20glowing%20in%20dark%20water%2C%20deep%20navy%20abyss%20with%20teal%20and%20orange%20bioluminescence%2C%20simple%20dark%20gradient%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=movie-cover-05&orientation=portrait",
    synopsis: "马里亚纳海沟深处传来一段规律的信号，国际科考队下潜调查，却逐渐意识到回声并非来自自然。密闭舱体内的恐惧与未知生物的低语交织，一部关于深海与未知的沉浸式惊悚之作。",
  },
  {
    id: "m6",
    title: "长安夜行",
    year: 2023,
    genres: ["古装", "动作"],
    region: "中国大陆",
    director: "徐枫",
    actors: ["易烊千玺", "张涵予", "辛柏青"],
    rating: 8.3,
    tags: ["热播"],
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20historical%20action%20film%20poster%2C%20a%20lone%20swordsman%20on%20a%20lantern-lit%20tang%20dynasty%20street%20at%20night%2C%20deep%20navy%20darkness%20with%20warm%20orange%20lantern%20glow%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=movie-cover-06&orientation=portrait",
    synopsis: "长安城一夜之间暗流涌动，一名身份成谜的旅人被卷入宫廷阴谋与江湖恩怨的交汇点。刀光与灯火之间，他要在一夜之内找出真相，也找回自己的名字。",
  },
  {
    id: "m7",
    title: "无声证人",
    year: 2024,
    genres: ["悬疑", "犯罪"],
    region: "韩国",
    director: "朴正洙",
    actors: ["李政宰", "金泰梨", "赵震雄"],
    rating: 8.6,
    tags: ["佳片"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20film%20poster%2C%20a%20shadowed%20interrogation%20room%20with%20a%20single%20hanging%20lamp%2C%20deep%20navy%20tones%20with%20warm%20orange%20highlight%2C%20simple%20dark%20minimal%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=movie-cover-07&orientation=portrait",
    synopsis: "一场没有目击者的命案，唯一的证人是无法开口的监控录像。当技术分析与人性谎言同时上演，真相往往藏在最沉默的角落。",
  },
  {
    id: "m8",
    title: "逐风少年",
    year: 2021,
    genres: ["青春", "运动"],
    region: "中国大陆",
    director: "曹阳",
    actors: ["彭昱畅", "谭松韵", "张宥浩"],
    rating: 7.6,
    tags: [],
    cover: "https://readdy.ai/api/search-image?query=Youth%20sports%20film%20poster%2C%20a%20young%20cyclist%20racing%20on%20a%20sunlit%20coastal%20road%2C%20bright%20navy%20sky%20with%20warm%20orange%20sunlight%2C%20simple%20minimal%20background%2C%20dynamic%20cinematic%20motion%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=movie-cover-08&orientation=portrait",
    synopsis: "被放弃的少年自行车手遇见了同样不被看好的退役教练，两个人决定用一场没人看好的比赛证明自己。关于热爱、失败与重新出发的青春故事。",
  },
  {
    id: "m9",
    title: "荒原列车",
    year: 2020,
    genres: ["西部", "剧情"],
    region: "美国",
    director: "Sam Whitaker",
    actors: ["Carl Dean", "Mabel Ross", "Ray Holt"],
    rating: 7.8,
    tags: [],
    cover: "https://readdy.ai/api/search-image?query=Western%20drama%20film%20poster%2C%20an%20old%20steam%20train%20crossing%20a%20vast%20desert%20plain%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20orange%20horizon%2C%20simple%20minimal%20background%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=movie-cover-09&orientation=portrait",
    synopsis: "一列载着陌生旅客的列车穿越大荒原，途中接连发生离奇事件，每个人都在隐藏自己的目的。慢节奏的公路寓言，关于孤独、救赎与去向。",
  },
  {
    id: "m10",
    title: "都市迷航",
    year: 2024,
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    director: "贾樟",
    actors: ["雷佳音", "马丽", "张子贤"],
    rating: 8.2,
    tags: ["新片"],
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20family%20drama%20film%20poster%2C%20a%20man%20standing%20alone%20among%20glowing%20city%20apartment%20windows%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20orange%20window%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=movie-cover-10&orientation=portrait",
    synopsis: "中年失业的父亲在一次意外的搬家途中，与叛逆的女儿被迫同行。城市夜晚的灯火照亮两个渐行渐远的人，也照亮了重新靠近的可能。",
  },
  {
    id: "m11",
    title: "幻影城市",
    year: 2025,
    genres: ["动作", "科幻"],
    region: "中国大陆",
    director: "陈思诚",
    actors: ["王一博", "张译", "周冬雨"],
    rating: 8.5,
    tags: ["热门"],
    cover: "https://readdy.ai/api/search-image?query=Cyberpunk%20action%20sci-fi%20poster%2C%20a%20running%20figure%20in%20a%20futuristic%20glowing%20city%20canyon%2C%20deep%20navy%20and%20teal%20with%20warm%20orange%20neon%2C%20simple%20dark%20background%2C%20dynamic%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=movie-cover-11&orientation=portrait",
    synopsis: "在一座由数据构建的虚拟都市里，记忆可以被交易、身份可以被改写。一名追查失踪案的数据警探，逐渐发现自己也是这座城市的一个程序。",
  },
  {
    id: "m12",
    title: "春山可望",
    year: 2022,
    genres: ["剧情", "爱情"],
    region: "中国台湾",
    director: "杨德",
    actors: ["桂纶镁", "陈柏霖", "许光汉"],
    rating: 8.0,
    tags: ["口碑"],
    cover: "https://readdy.ai/api/search-image?query=Gentle%20romantic%20drama%20poster%2C%20two%20figures%20walking%20along%20a%20misty%20green%20mountain%20trail%20at%20sunrise%2C%20soft%20cream%20and%20navy%20with%20warm%20orange%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=movie-cover-12&orientation=portrait",
    synopsis: "多年后回到故乡的两人，在同一座山城重逢。二十年的书信、错过与沉默，都在一个春天里重新被打开。关于时间如何温柔地治愈一段感情。",
  },
  {
    id: "m13",
    title: "铁血黎明",
    year: 2019,
    genres: ["战争", "历史"],
    region: "中国大陆",
    director: "冯小刚",
    actors: ["张涵予", "段奕宏", "朱亚文"],
    rating: 8.4,
    tags: ["经典"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20war%20historical%20film%20poster%2C%20soldiers%20silhouetted%20against%20a%20burning%20dawn%20sky%2C%20deep%20navy%20smoke%20with%20warm%20orange%20fire%20glow%2C%20simple%20minimal%20background%2C%20cinematic%20dramatic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=movie-cover-13&orientation=portrait",
    synopsis: "黎明前的最后一场战役里，一支残破的连队守护着身后的家园。影片以粗粝写实的镜头还原战争残酷，也记录普通人在历史洪流中的勇气。",
  },
  {
    id: "m14",
    title: "猫眼侦探",
    year: 2023,
    genres: ["喜剧", "悬疑"],
    region: "英国",
    director: "Oliver Grant",
    actors: ["Benedict Hall", "Amelia Stone", "Jack Prowse"],
    rating: 7.7,
    tags: [],
    cover: "https://readdy.ai/api/search-image?query=Playful%20British%20comedy%20mystery%20poster%2C%20a%20black%20cat%20on%20a%20vintage%20desk%20beside%20a%20magnifying%20glass%20and%20lamp%2C%20deep%20navy%20tones%20with%20warm%20orange%20light%2C%20simple%20minimal%20background%2C%20editorial%20illustration%2C%20no%20text&width=400&height=600&seq=movie-cover-14&orientation=portrait",
    synopsis: "一位落魄的私家侦探唯一的搭档是一只倔强的流浪猫，他们却在最不起眼的街区里破获了一系列离奇小案。轻松幽默又带点古典推理的英式小品。",
  },
  {
    id: "m15",
    title: "最后一家书店",
    year: 2021,
    genres: ["剧情", "文艺"],
    region: "法国",
    director: "Claire Dubois",
    actors: ["Audrey Marchand", "Louis Berger", "Nina Roux"],
    rating: 8.1,
    tags: ["佳片"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20art%20house%20drama%20poster%2C%20a%20quiet%20old%20bookshop%20interior%20with%20stacks%20of%20books%20and%20afternoon%20light%2C%20cream%20and%20amber%20tones%20with%20deep%20navy%20shadows%2C%20simple%20minimal%20background%2C%20editorial%20photography%2C%20no%20text&width=400&height=600&seq=movie-cover-15&orientation=portrait",
    synopsis: "塞纳河畔一家百年书店面临拆迁，固执的老店主与偶然停驻的年轻读者决定为它做最后一件事。关于纸页、记忆与城市里那些不肯消失的角落。",
  },
  {
    id: "m16",
    title: "极光之下",
    year: 2024,
    genres: ["爱情", "冒险"],
    region: "冰岛",
    director: "Lars Nilsen",
    actors: ["Freya Lind", "Erik Holm", "Anna Berg"],
    rating: 7.9,
    tags: ["新片"],
    cover: "https://readdy.ai/api/search-image?query=Romantic%20adventure%20film%20poster%2C%20two%20travellers%20standing%20under%20green%20northern%20lights%20in%20a%20snowy%20landscape%2C%20deep%20navy%20night%20sky%20with%20teal%20and%20warm%20orange%20aurora%2C%20simple%20minimal%20background%2C%20cinematic%20wide%20shot%2C%20no%20text&width=400&height=600&seq=movie-cover-16&orientation=portrait",
    synopsis: "两名素不相识的旅行者为了各自的目的搭上同一辆环岛巴士，在极夜的冰岛一起追寻那场传说中的极光。一场关于放手与重新相信的温柔旅程。",
  },
  {
    id: "m17",
    title: "量子裂缝",
    year: 2025,
    genres: ["科幻", "悬疑"],
    region: "美国",
    director: "David Chen",
    actors: ["Oscar Reed", "Mia Novak", "Tomas Vega"],
    rating: 8.8,
    tags: ["热门"],
    cover: "https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20mystery%20poster%2C%20a%20split%20mirror%20corridor%20with%20glowing%20geometry%20and%20one%20solitary%20figure%2C%20deep%20navy%20and%20violet-free%20teal%20with%20warm%20orange%20glow%2C%20simple%20dark%20background%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=movie-cover-17&orientation=portrait",
    synopsis: "一次失败的量子实验让同一个人分裂成两条时间线，为了修复现实的裂缝，两个他必须做出截然相反的选择。烧脑设定之下，是关于自我与命运的追问。",
  },
  {
    id: "m18",
    title: "归途列车",
    year: 2023,
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    director: "李睿珺",
    actors: ["黄渤", "周冬雨", "杨新鸣"],
    rating: 8.3,
    tags: ["口碑"],
    cover: "https://readdy.ai/api/search-image?query=Emotional%20family%20drama%20poster%2C%20a%20green%20train%20crossing%20a%20rural%20snowy%20landscape%20at%20dusk%2C%20deep%20navy%20winter%20tones%20with%20warm%20orange%20window%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=movie-cover-18&orientation=portrait",
    synopsis: "在外打工多年的父亲带着一身疲惫踏上回乡的列车，一路上遇见的陌生人让他重新理解了家与牵挂的重量。一趟跨越千里的情感旅程。",
  },
];

export const movieGenres = ["全部", "科幻", "犯罪", "悬疑", "剧情", "爱情", "冒险", "动作", "喜剧", "战争", "古装", "青春", "运动"];
export const regions = ["全部", "中国大陆", "中国香港", "中国台湾", "美国", "韩国", "英国", "法国", "冰岛"];
export const years = ["全部", "2025", "2024", "2023", "2022", "2021", "2020", "2019"];